import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
// The shell's aggregate stylesheet defines the --ofself-* design tokens
// (text ladder, font stacks, weights) that missions' CSS consumes. It must
// load BEFORE the app's own CSS so the tokens resolve and app rules win ties.
import '@ofself/shell/styles.css';
// Space Grotesk — the missions index's display voice (the brutalist wall).
import '@fontsource-variable/space-grotesk';
// Missions' own styles load AFTER the kit's (which ride in with the shell
// components imported by App.jsx), so app CSS wins ties the same way it does
// in every shell host.
import './legacy/style.css';
import './missions.css';

createRoot(document.getElementById('root')).render(<App />);
